<template>
    <multiselect
        v-model="selected_value"
        :options="options"
        :searchable="true"
        :placeholder="'Search by email'"
        selectLabel="Select"
        deselectLabel=""
        selectedLabel=""
        :disabled="disabled"
        :multiple="multiple"
        :loading="loading"
        :label="label"
        trackBy="id"
        @search-change="getData"
        style="min-width: 200px"
        label="name"
    >
        <template slot="noResult"> Not found</template>
        <template slot="noOptions"> Search by email</template>
        <template slot="caret">
            <inline-svg class="multiselect-icon" src="/assets/img/icons/search-icon.svg"></inline-svg>
        </template>
    </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import debounce from 'lodash/debounce';

export default {
    name: 'UserSelect',
    props: ['value', 'disabled', 'multiple', 'user_type', 'placeholder', 'label', 'searchByEmail', 'autoClean'],
    components: {Multiselect},
    data() {
        return {
            selected_value: null,
            loading: false,
            options: [],
        };
    },
    methods: {
        getData: debounce(function (query) {
            if (!query) {
                return;
            }
            this.loading = true;
            let data = {};
            if (this.user_type) {
                data.user_type = this.user_type
            }
            if (this.searchByEmail) {
                data.email = query
            }else {
                data.query = query;
            }
            this.$http.post('/user/search', data)
                .then(function (res) {
                    this.loading = false;
                    this.options = res.body.data;
                }).catch(() => {
                this.loading = false;
            });
        }, 500),
    },
    watch: {
        value(a) {
            this.selected_value = a;
        },
        selected_value(option) {
            if (this.autoClean) {
                if (option) {
                    this.$emit('input', option);
                    this.$emit('change', option);
                    this.$emit('setId', option ? option.id : null);
                }
                this.selected_value= null;
                return;
            }
            if (!option) {
                this.$emit('input', null);
                this.$emit('change', null);
                this.$emit('setId', null);
            } else {
                this.$emit('input', option);
                this.$emit('change', option);
                this.$emit('setId', option ? option.id : null);
            }
        },
    },
    mounted() {
        if (this.value) {
            this.selected_value = this.value;
        }
    },
};
</script>
